<div class="mainCt absolute top-0 flex items-center h-16 lg:h-[120px] w-full drop-shadow"  [ngClass]="searchMobileOpen() ? 'searchbox-mobile-opened' : ''">
  <div class="ct container mx-auto h-[inherit]" [ngClass]="isLoggedIn() ? 'xl:max-w-[1820px]' : ''">
    <nav class="flex items-center w-full text-2xl whitespace-nowrap overflow-hidden h-[inherit]">
      <div class="flex-grow overflow-hidden relative h-[inherit]">
          <div id="searchbox-wrap" class="flex items-center flex-nowrap absolute top-0 left-0 w-[550px] h-[inherit]" 
          [@searchBoxAnim]="searchMobileOpen() ? 'searchboxOpened' : 'searchboxClosed'"  (@searchBoxAnim.done)="searchBoxAnimDone($event)" [ngClass]="searchBoxWrapperCss()">
          @defer (on timer(200ms)) {
            <button mat-icon-button class="w-14 h-14" [ngClass]="searchMobileOpen() ? 'hidden' : isLoggedIn() ? '' : 'lg:!hidden'"
              (click)="toolbarService.toggleLeftSidebarOpen()" i18n-aria-label aria-label="Menu">
              <mat-icon svgIcon="core:menu"></mat-icon>
            </button>
          } @placeholder  {
            <button mat-icon-button class="w-14 h-14 block lg:!hidden" i18n-aria-label aria-label="Menu">
              <mat-icon svgIcon="core:menu"></mat-icon>
            </button>
          }

        
          <a class="w-auto" routerLink="/online-fair" aria-label="Expometals.net">
            <exp-logo id="tb-logo" class="w-[218px] h-[85px]"></exp-logo>
          </a>

          <div id="search-box" #searchbox class="w-full md:w-auto overflow-hidden flex md:flex-grow md:px-7 place-content-center items-center invisible md:visible" [ngClass]="toolbarService.hideToolbar() ? 'md:invisible': ''">
            @defer (on hover; when searchMobileOpen()) {
              <search-box></search-box>
            }
            @placeholder {
              <div class="w-full flex place-content-center">
                <div id="dummy-searchbox"
                      class="relative w-0 md:w-full box-content border-b border-current bg-transparent
                            mb-[22px] pt-6 pb-2 pl-4 max-w-lg font-normal text-xl max-h-[18px]"
                  [ngClass]="toolbarService.isTransparent() ? 'placeholder-white' : ''">
                  <label for="dummy_input_sb" class="absolute top-4" i18n>Search</label>
                  <input id="dummy_input_sb" type="text" class="bg-transparent" />
                </div>
              </div>
              <!-- <search-box></search-box> -->
            }
          </div>
        </div>
      </div>


      <div class="flex place-content-end md:hidden lg:mr-0">
        <button (click)="toogleSearchBox()" mat-icon-button i18n-aria-label aria-label="Search">
          <!--  ICONA DEL CERCA PER RESPONSIVE  Il defer dell'icona elimina Long Task (updateSvgIcon)-->
          @defer(on timer(200ms)) {
            <mat-icon class="!w-10 !h-auto" svgIcon="core:search" [style.display]="searchMobileOpen() ? 'none' : 'block'"></mat-icon>
          } 
          @placeholder {
            <mat-icon class="!w-10 !h-auto block" svgIcon="core:search"></mat-icon>
          }
          
          <mat-icon class="!w-10 !h-auto" svgIcon="core:close" [style.display]="searchMobileOpen() ? 'block' : 'none'"></mat-icon>
        </button>
      </div>


        <a routerLink="/online-fair-hall" routerLinkActive="is-active" class="action hidden lg:inline" i18n>Online fair</a>

        <a class="action hidden lg:inline" routerLink="/news" matBadgeColor="warn">
          <span i18n>News</span>
          <span class="ml-1" [matBadge]="getBadgeValue()" matBadgeOverlap="false" matBadgeColor="warn"></span>
        </a>
        

        <a routerLink="/products" routerLinkActive="is-active" class="action hidden lg:inline">
          <span i18n>Products</span>
        </a>

        <!-- <div fxLayoutAlign="start center" class="action">
        <span id="products-badge" matBadge="20" matBadgeOverlap="false" matBadgeColor="warn">Marketplace</span>
      </div> -->


        <li>
          <a routerLink="/events" routerLinkActive="is-active" class="action hidden lg:inline">
            <span i18n>Events</span> 
           </a>
        </li>


        <a routerLink="/sponsor" routerLinkActive="is-active" class="action hidden lg:inline">
          <span i18n>Sponsors</span>
        </a>

        @if (!isLoggedIn()) {
          <button (click)="showNewsletterBanner()" class="action hidden xl:inline" i18n-aria-label aria-label="Newsletter">
            <span i18n>Newsletter</span>
          </button>
        }

        <div class="toolbar-separator"></div>


        <!-- USER MENU -->
        @if (isLoggedIn()) {
          <toolbar-menu></toolbar-menu>
        }
        @else {
          <button (click)="login()" routerLinkActive="is-active" class="space-x-4 action hidden xs:flex" i18n-aria-label aria-label="Sign in">
            <span i18n>Sign in</span>
          </button>
        }
        <div class="flex place-content-end lg:hidden lg:mr-20"><div class="flex flex-row items-center place-content-center max-h-full box-border lg:hidden -ml-3" [style.display]="searchMobileOpen() ? 'none' : 'block'">
          @defer(on timer(200ms)) {
            <button mat-icon-button class="navbar-toggle-button" (click)="toolbarService.toggleRightSidebarOpen()" i18n-aria-label aria-label="Categories">
              <mat-icon svgIcon="core:space_dashboard_black"></mat-icon>
            </button>
          } 
          @placeholder {
            <button mat-icon-button class="navbar-toggle-button" i18n-aria-label aria-label="Categories">
              <mat-icon svgIcon="core:space_dashboard_black"></mat-icon>
            </button>
          }

        </div></div>
        


        <!-- LANGUAGE MENU -->
        <div class="hidden xl:inline">
          <!-- @defer (on timer(2s)) { -->
          @defer () {
            <language-menu></language-menu>
          }
          @placeholder {
            <div class="hidden md:flex items-center px-4 py-[10px]">
              <flag [countryCode]="selectedLanguage.flag"></flag>
            </div>
          }
      </div>
    </nav>
  </div>
</div>
